export default {
  // Tabs / sections
  'aes.tab.info': 'Info',
  'aes.tab.documents': 'Documents',
  'aes.section.filing': 'Filing & Shipment',
  'aes.section.transport': 'Transport',
  'aes.section.parties': 'Parties',
  'aes.section.commodity_items': 'Commodity Items',
  'aes.contact.section': 'AES Setting',
  'aes.contact.id_type': 'AES ID Type',
  'aes.contact.id_no': 'AES ID No.',

  // Filing & shipment fields
  'aes.field.filer_ein_type': 'Filer ID Type',
  'aes.field.filer_ein': 'Filer ID',
  'aes.field.filing_option': 'Filing Option',
  'aes.field.aei_filing_type': 'AEI Filing Type',
  'aes.field.shipment_file_number': 'Shipment File No.',
  'aes.field.shipment_number': 'Shipment No.',
  'aes.field.itn_no': 'ITN No.',
  'aes.field.mode_of_transport_code': 'Mode of Transport',
  'aes.field.op_type': 'Operation Type',
  'aes.field.ultimate_country': 'Ultimate Country',
  'aes.field.state_of_origin': 'State of Origin',
  'aes.field.carrier': 'Carrier',
  'aes.field.carrier_code': 'Carrier Code (SCAC/IATA)',
  'aes.field.carrier_qualifier': 'Carrier Code Type',
  'aes.field.vessel': 'Vessel / Conveyance',
  'aes.field.port_of_loading': 'Port of Loading',
  'aes.field.loading_date': 'Loading Date',
  'aes.field.port_of_discharge': 'Port of Discharge',
  'aes.field.discharge_date': 'Discharge Date',
  'aes.field.routed_export_indicator': 'Routed Export Transaction',
  'aes.field.related_company_indicator': 'Related Company',
  'aes.field.hazmat_indicator': 'Hazardous Material',
  'aes.field.inbond_type': 'In-bond Type',
  'aes.field.inbond_number': 'In-bond No.',
  'aes.field.foreign_trade_zone': 'Foreign Trade Zone',
  'aes.field.entry_number': 'Entry No.',
  'aes.field.master_bill_number': 'Master Bill No.',

  // Filing option labels
  'aes.option.filing.2': '2 - Predeparture (full)',
  'aes.option.filing.3': '3 - Advance Export Information (AEI)',
  'aes.option.filing.4': '4 - Postdeparture',
  'aes.option.aei.P': 'P - Partial predeparture',
  'aes.option.aei.F': 'F - Full postdeparture',
  'aes.option.op.OE': 'OE - Ocean Export',
  'aes.option.op.AE': 'AE - Air Export',
  'aes.option.op.DO': 'DO - Domestic',
  'aes.option.mot.10': '10 - Sea',
  'aes.option.mot.11': '11 - Sea Containerized',
  'aes.option.mot.12': '12 - Sea (Barge)',
  'aes.option.mot.20': '20 - Rail',
  'aes.option.mot.21': '21 - Rail Containerized',
  'aes.option.mot.30': '30 - Truck',
  'aes.option.mot.31': '31 - Truck Containerized',
  'aes.option.mot.32': '32 - Auto',
  'aes.option.mot.33': '33 - Pedestrian',
  'aes.option.mot.34': '34 - Road, Other',
  'aes.option.mot.40': '40 - Air',
  'aes.option.mot.41': '41 - Air Containerized',
  'aes.option.mot.50': '50 - Mail',
  'aes.option.mot.60': '60 - Passenger, Hand Carried',
  'aes.option.mot.70': '70 - Fixed Transport',
  'aes.option.inbond.36': '36 - Warehouse withdrawal for IE',
  'aes.option.inbond.37': '37 - Warehouse withdrawal for T&E',
  'aes.option.inbond.67': '67 - FTZ withdrawal for IE',
  'aes.option.inbond.68': '68 - FTZ withdrawal for T&E',
  'aes.option.inbond.70': '70 - Not shipped in-bond',

  // Parties
  'aes.party.usppi': 'USPPI (US Principal Party in Interest)',
  'aes.party.forwarding_agent': 'Forwarding Agent',
  'aes.party.ultimate_consignee': 'Ultimate Consignee',
  'aes.party.intermediate_consignee': 'Intermediate Consignee',
  'aes.field.ultimate_consignee_type': 'Ultimate Consignee Type',
  'aes.option.consignee.D': 'D - Direct Consumer',
  'aes.option.consignee.G': 'G - Government Entity',
  'aes.option.consignee.O': 'O - Other/Unknown',
  'aes.option.consignee.R': 'R - Reseller',

  // Commodity item fields
  'aes.field.commodity.hts_number': 'Schedule B / HTS No.',
  'aes.validation.commodity.hts_number.required':
    'Schedule B / HTS Number is required unless Export Code is HH.',
  'aes.validation.commodity.hts_number.invalid':
    'Schedule B / HTS Number must be exactly 10 digits.',
  'aes.field.commodity.description': 'Description',
  'aes.field.commodity.qty1': 'Quantity 1',
  'aes.field.commodity.qty1_unit': 'Unit 1',
  'aes.validation.commodity.qty1_unit.required':
    'Quantity 1 Unit is required unless Export Code is HH.',
  'aes.validation.commodity.qty1_unit.invalid': 'Select a valid AES Quantity 1 Unit code.',
  'aes.field.commodity.qty2': 'Quantity 2',
  'aes.field.commodity.qty2_unit': 'Unit 2',
  'aes.field.commodity.origin': 'Origin',
  'aes.field.commodity.value': 'Value (USD)',
  'aes.field.commodity.gross_weight': 'Gross Weight (KG)',
  'aes.field.commodity.export_code': 'Export Code',
  'aes.field.commodity.license_type': 'License Type',
  'aes.field.commodity.eccn': 'ECCN',
  'aes.field.commodity.license_number': 'License No.',
  'aes.option.origin.D': 'D - Domestic',
  'aes.option.origin.F': 'F - Foreign',
  'aes.commodity.add': 'Add Commodity Item',
  'aes.commodity.edit': 'Edit Commodity Item',
  'aes.commodity.empty': 'At least one commodity item is required.',

  // Status / list
  'aes.title.new': 'New',
  'aes.field.status': 'Status',
  'aes.list.ext_id': 'Shipment File No.',
  'aes.list.shipment_number': 'Shipment No.',
  'aes.list.op_type': 'Operation',
  'aes.list.carrier': 'Carrier',
  'aes.list.port_of_loading': 'POL',
  'aes.list.port_of_discharge': 'POD',
  'aes.list.create': 'Create',

  // Messages
  'aes.save.success': 'AES saved successfully',
  'aes.save.error': 'Failed to save AES',
  'aes.update.success': 'AES updated successfully',
  'aes.submit.success': 'AES submitted successfully',
  'aes.submit.error': 'Failed to submit AES',
  'aes.submit.save_first': 'Please save the AES first before submitting',
  'aes.delete.success': 'AES deleted',
  'aes.delete.confirm': 'Delete this AES filing?',
  'aes.parties.required': 'USPPI and Ultimate Consignee are required (at least two parties).',
  'aes.parties.incomplete':
    'Please correct missing or invalid AES contact information for: {parties}.',
  'aes.contact_status.title': 'Contact Information Status',
  'aes.contact_status.complete': '✓ Ready for AES filing',
  'aes.contact_status.missing': 'Missing or invalid: {fields}',
  'aes.contact_status.incomplete':
    'Contact information must be complete and valid before AES filing.',
  'aes.contact_status.missing.name': 'Name',
  'aes.contact_status.missing.address': 'Address',
  'aes.contact_status.missing.country': 'Country',
  'aes.contact_status.missing.invalid_country_code': 'Invalid country code (must be 2 characters)',
  'aes.contact_status.missing.invalid_subdivision_code':
    'Invalid state / subdivision code (must be 2 characters)',
  'aes.contact_status.missing.us_country': 'Country must be United States',
  'aes.contact_status.missing.aes_id': 'AES ID Type and No.',
  'aes.contact_status.missing.ultimate_consignee_type': 'Ultimate Consignee Type',
  'aes.party_snapshot.name': 'Name',
  'aes.party_snapshot.tax_id': 'Tax ID',
  'aes.party_snapshot.type': 'Type',
  'aes.party_snapshot.ultimate_consignee_type': 'Ultimate Consignee Type',
  'aes.party_snapshot.irs_number': 'IRS Number',
  'aes.party_snapshot.address_1': 'Address 1',
  'aes.party_snapshot.address_2': 'Address 2',
  'aes.party_snapshot.city': 'City',
  'aes.party_snapshot.zip_code': 'Zip Code',
  'aes.party_snapshot.state': 'State',
  'aes.party_snapshot.country': 'Country',
  'aes.party_snapshot.contact_person': 'Contact Person',
  'aes.party_snapshot.contact_first_name': 'Contact First Name',
  'aes.party_snapshot.contact_last_name': 'Contact Last Name',
  'aes.party_snapshot.contact_phone': 'Contact Phone',
  'aes.party_snapshot.contact_email': 'Contact Email',
  'aes.party_snapshot.contact_fax': 'Contact Fax',
  'aes.action.refresh_status': 'Refresh Status / ITN',
  'aes.action.gsf_status': 'Open GSF Status',
  'aes.itn.refresh.success': 'AES status and ITN refreshed',
  'aes.itn.not_available': 'ITN is not available yet',
  'aes.status_url.unavailable': 'GSF status page is unavailable',
  'aes.amend.confirm': 'Amend this AES filing and make it editable?',
  'aes.amend.success': 'AES is ready to amend',
  'aes.changelog.gsf_status': 'CBP/GSF Status',
};
